import React, { useMemo } from "react";
import { Link, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { RiDashboardFill } from "react-icons/ri";
import { GoTasklist } from "react-icons/go";
import { FaUserClock } from "react-icons/fa6";
import { MdOutlineEmail } from "react-icons/md";
import { LiaProjectDiagramSolid } from "react-icons/lia";
import { IoIdCardOutline } from "react-icons/io5";
import { HiOutlineSquares2X2 } from "react-icons/hi2";
import { useServiceProviderMenu } from "../../serviceProvider/components/sidebar/Sidebar";

// Everyday destinations, in priority order. The first four the user may open are shown; the
// rest of the navigation stays one tap away behind "Menu".
const SHORTCUTS = [
  { key: "Dashboard", to: "/user", label: "Dashboard", icon: RiDashboardFill, exact: true },
  { key: "Tasks", to: "/user/tasks", label: "Tasks", icon: GoTasklist },
  { key: "Calendar", to: "/user/calendar", label: "Appointments", icon: FaUserClock },
  { key: "Mail", to: "/user/mail", label: "Mail", icon: MdOutlineEmail },
  { key: "Projects", to: "/user/projects", label: "Projects", icon: LiaProjectDiagramSolid },
  { key: "Boards", to: "/user/Boards", label: "Tickets", icon: IoIdCardOutline }
];

const collectKeys = items =>
  items.flatMap(item => [item.key, ...(item.children ? collectKeys(item.children) : [])]);

const MobileBottomNav = ({ onOpenMenu, menuOpen }) => {
  const { t } = useTranslation("dashboard");
  const { pathname } = useLocation();
  const menuItems = useServiceProviderMenu();

  const shortcuts = useMemo(() => {
    const allowed = new Set(collectKeys(menuItems));
    return SHORTCUTS.filter(s => allowed.has(s.key)).slice(0, 4);
  }, [menuItems]);

  const isActive = s =>
    s.exact ? pathname === s.to : pathname === s.to || pathname.startsWith(`${s.to}/`);
  const anyShortcutActive = shortcuts.some(isActive);

  return (
    <nav className="app-bottomnav" aria-label={t("Main navigation")}>
      {shortcuts.map(s => {
        const Icon = s.icon;
        const active = !menuOpen && isActive(s);
        return (
          <Link
            key={s.key}
            to={s.to}
            className={`app-bottomnav__item${active ? " is-active" : ""}`}
            aria-current={active ? "page" : undefined}
          >
            <span className="app-bottomnav__icon">
              <Icon aria-hidden="true" />
            </span>
            <span>{t(s.label)}</span>
          </Link>
        );
      })}
      <button
        type="button"
        className={`app-bottomnav__item${menuOpen || !anyShortcutActive ? " is-active" : ""}`}
        onClick={onOpenMenu}
        aria-expanded={menuOpen}
      >
        <span className="app-bottomnav__icon">
          <HiOutlineSquares2X2 aria-hidden="true" />
        </span>
        <span>{t("Menu")}</span>
      </button>
    </nav>
  );
};

export default MobileBottomNav;
